module.exports = __webpack_public_path__ + "static/media/add-logo-tabletPro-es.2efbfd5c.png";